import React from "react"
import {values} from "lodash"
import {Dialog} from "react-weui"
import { X } from "react-feather"
import PropTypes from "prop-types"

import './MenuModal.less'

export default class MenuModal extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { }
  }

  render() {
    const { menu, onClose } = this.props
    return  (
      <Dialog
        id="MenuModal"
        type="ios"
        show 
        style={{
          maxWidth: window.matchMedia("(min-width: 735px)").matches ? "360px" : "90%",
          width: window.matchMedia("(min-width: 735px)").matches ? "360px" : "90%",
          maxHeight: "95%",
          padding: "0.5vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <header>
          {menu.chName}
          <X size="30px" onClick={() => onClose()} />
        </header>

        <div className="dishesContainer">  
          {values(menu.dishes).map(dish => (
            <div key={dish.id} className="dish">
              <div
                className="dishimage"
                style={{
                  backgroundImage: `url(${dish.background.image})`,
                }}
              />
              <div className="texts">
                <div className="dishtitle">{dish.chName}</div>
                <div className="dishdescription">{dish.description}</div>
              </div>
            </div>
              
          ))}
        </div>
      </Dialog>
    )
  }
}

MenuModal.propTypes = {
  menu: PropTypes.object.isRequired, 
  onClose: PropTypes.func, 
}


// WEBPACK FOOTER //
// ./src/app/catalogo/reservation/components/MenuModal.jsx